import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "src/contexts/auth-provider";
import { parseRestaurantSegment, restaurantSegment } from "src/utils/restaurantUrl";

interface RequireFeatureProps {
  feature: string;
  children: React.ReactNode;
}

/**
 * Renders children only when the user has the given feature permission.
 * Otherwise redirects to restaurant settings (or My Restaurants if no restaurant context).
 */
export const RequireFeature: React.FC<RequireFeatureProps> = ({
  feature,
  children,
}) => {
  const { permissions, hasRestaurant } = useAuth();
  const { restaurantSlugAndId, restaurantCorrelationId } = useParams<{ restaurantSlugAndId?: string; restaurantCorrelationId?: string }>();
  const fromSegment = restaurantSlugAndId ? parseRestaurantSegment(restaurantSlugAndId).correlationId : null;
  const correlationId = fromSegment ?? restaurantCorrelationId ?? hasRestaurant?.correlationId;

  if (permissions[feature]) {
    return <>{children}</>;
  }

  const redirectTo = correlationId
    ? `/restaurants/${restaurantSegment(correlationId, hasRestaurant?.name)}/restaurant-setting`
    : "/my-restaurants";
  return <Navigate to={redirectTo} replace />;
};
